import { Action, ActionTypes, IState } from './types'

export function reducer(state: IState, action: Action): IState {
  switch (action.type) {
    case ActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.value,
      }
    case ActionTypes.SET_OFFLINE_MODE:
      return { ...state, offlineMode: action.value }
    case ActionTypes.SET_UN_SAVED_JOB_COUNT:
      return { ...state, unSavedJobCount: action.value }
    case ActionTypes.SHOW_SOCKET_MESSAGES:
      return { ...state, showMessages: true }
    case ActionTypes.HIDE_SOCKET_MESSAGES:
      return { ...state, showMessages: false }
    case ActionTypes.SET_MESSAGE_COUNT:
      return { ...state, messageCount: action.value }
    default:
      return state
  }
}
